import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import { BASIC_BUTTON_TYPE_OUTLINED } from '@divvy-web/skylab.basicbutton'

import GoToDashboardButton from '@sputnik/components/GoToDashboardButton'
import ImageWrapper from '@sputnik/components/ImageWrapper'
import LogoutButton from '@sputnik/components/LogoutButton'

import styles from './styles.module.scss'

const ErrorPage = () => {
  const [getClassName] = useNameFormatter('ErrorPage')

  return (
    <div className={styles[getClassName('')]}>
      <div className={styles[getClassName('main-content')]}>
        <ImageWrapper
          alt='person throwing trash away'
          className={styles[getClassName('image')]}
          data-testid='image-404'
          imageName='office_desk'
        />
        <div
          className={styles[getClassName('message')]}
          data-testid='message-404'
        >
          <FormattedMessage
            defaultMessage='Looks like something went wrong, please try again later.'
            id='sputnik.ErrorPage__uU7tNC'
          />
        </div>
        <div className={styles[getClassName('buttons')]}>
          <LogoutButton buttonType={BASIC_BUTTON_TYPE_OUTLINED} />
          <GoToDashboardButton componentName={getClassName('')} />
        </div>
      </div>
    </div>
  )
}

export default ErrorPage
